import React from "react";

import { useTranslation } from "utils";

import { Flex, InputSearch } from "components";

export type FieldSearchFilterBarProps = {
  searchQuery: string;
  onSearchQueryChange: (value: string) => void;
  searchDisabled?: boolean;
  // e.g. the "+" add/bulk-field context menu on the all-fields view
  leadingActions?: React.ReactNode;
  // reserved for the table-view page's year selector, which will replace the DGF's title + year selector
  yearSelector?: React.ReactNode;
  // e.g. FieldFilterOptions / FieldFilterOptionsChips
  filters?: React.ReactNode;
  // e.g. RecommendationSwitch + ImportCropsButton on the all-fields view
  trailingActions?: React.ReactNode;
};

export const FieldSearchFilterBar = ({
  searchQuery,
  onSearchQueryChange,
  searchDisabled,
  leadingActions,
  yearSelector,
  filters,
  trailingActions,
}: FieldSearchFilterBarProps) => {
  const { t } = useTranslation("allFieldView");

  return (
    <Flex className="all-field-view filter-bar" justify="space-between" align="center">
      <Flex className="search-container" align="center">
        <InputSearch
          dataTestId="filter-fields"
          className="search-input"
          isSmallVariant
          label={t("search")}
          onChange={(e) => onSearchQueryChange(e.target.value)}
          value={searchQuery}
          disabled={searchDisabled}
        />
      </Flex>
      {leadingActions}
      {yearSelector}
      <Flex className="filters-container" justify="space-between" align="center" gap="1rem">
        <Flex align="center">{filters}</Flex>
        <Flex className="recommendation-toggle-container" align="center" gap="1rem">
          {trailingActions}
        </Flex>
      </Flex>
    </Flex>
  );
};
